import React from 'react';
import AppleStoreIcon from "../../../static/images/AppleStoreIcon.png"
import GooglePlayIcon from "../../../static/images/GooglePlayIcon.png"

const AppStoreLinks = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",
      }}
    >
      <a
        href="https://play.google.com/store/apps/details?id=com.sourceviewbible"
        target="_blank"
      >
        <img src={GooglePlayIcon} height={75} className="appstoreLogo" />
      </a>
      <a
        href="https://apps.apple.com/us/app/sourceview-bible/id1114617271"
        target="_blank"
      >
        <img src={AppleStoreIcon} height={75} className="appstoreLogo" />
      </a>
    </div>
  )
}

export default AppStoreLinks;